import React from "react";

type DecimalNumberCentsProps = {
  value: string | number;
  className?: string;
  prefix?: string;
};

const DecimalNumberCents: React.FC<DecimalNumberCentsProps> = ({
  value,
  className,
}) => {
  const formattedValue = !!value
    ? parseFloat(String(value)).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })
    : "";

  return (
    <div>
      <span className={className}>{formattedValue}</span>
    </div>
  );
};

export default DecimalNumberCents;
